import { useFundStatementPeriodSection } from '../../../hooks/useFundStatementPeriodSection';
import { FundStatementPeriodView } from './FundStatementPeriodView';

export function FundStatementPeriodSection({ dealerId }: { dealerId: string }) {
    return <FundStatementPeriodView {...useFundStatementPeriodSection(dealerId)} />;
}
